export const AUTH_APP_URL = '<%ENV= AUTH_APP_URL %>'
export const SUBSCRIBE_AUTH_STATE = 'SUBSCRIBE_AUTH_STATE'
export const AUTH_STATE_UPDATED = 'AUTH_STATE_UPDATED'
export const canvasWidth = 460
export const canvasHeight = 655
export const headerHeight = 50
export const screenWidth = 420
export const screenCentreX = screenWidth / 2
export const screenHeaderHeight = headerHeight
export const screenBodyHeight = 570
export const toolHeight = 450
export const lightBlue = 0x3690D3
export const mediumBlue = 0x3F7292
export const darkBlue = 0x1B587E
export const darkestBlue = 0x4A6D89
export const green = 0x59C104
export const red = 0xE5705D
export const orange = 0xFF9E0A
export const grey = 0xD6D6D6
export const lightBlueGrey = 0xAAD4E7
export const tick = '\uE5A2'
export const cross = '\uE5A3'
export const upArrow = '\uE5A8'
export const downArrow = '\uE5A9'
export const multiplicationSign = '\u00D7'
